<template>
<div>
  <h1>{{pageHeading}}</h1>
  <div v-if="authenticating" class="authenticating">
    <div v-if="authenticationError">
      {{ authenticationError }}
    </div>
    <div v-else>
      Authenticating ...
    </div>
  </div>
  <b-form v-if="formEnabled" class="create-form">
    <b-form-group
      label="Location:"
      label-for="location"
      invalid-feedback="Must Choose Location"
      :state="locationState">
        <b-form-select id="location"
          label="Location:"
          :options="locationOptions"
          v-model="newNotification.FunctLoc">
        </b-form-select>
    </b-form-group>

    <b-form-group
      v-show="newNotification.FunctLoc"
      label="Equipment:"
      label-for="equipment"
      invalid-feedback="Must Choose Equipment"
      :state="equipmentState">
        <b-form-select id="equipment"
          label="Equipment:"
          :options="equipmentOptions"
          v-model="newNotification.equipmentId">
        </b-form-select>
    </b-form-group>

    <b-form-group
      label="Priority:"
      label-for="priority"
      invalid-feedback="Must Choose Priority"
      :state="priorityState">
        <b-form-select id="priority"
          :options="priorities"
          v-model="newNotification.priority">
        </b-form-select>
    </b-form-group>

    <b-form-group
      label="Short Description:"
      label-for="sdesc"
      invalid-feedback="Must Enter Short Description"
      :state="shortDescriptionState">
        <b-form-input id="sdesc"
          v-model="newNotification.shortDesc"
          placeholder="Enter Short Desc"
          maxlength="40">
        </b-form-input>
    </b-form-group>

    <b-form-group
      label="Long Description:"
      label-for="ldesc"
      invalid-feedback="Must Enter Long Description"
      :state="longDescriptionState">
        <b-form-input id="ldesc"
          v-model="newNotification.longDesc"
          placeholder="Enter Long Desc"
          invalid-feedback="Must Enter Long Description">
        </b-form-input>
    </b-form-group>

    <b-form-group
      label="Reported by:"
      label-for="sapid"
      invalid-feedback="Must Enter SAP User Id or Name"
      :state="sapIdState">
        <b-form-input id="sapid"
          v-model="newNotification.SAPId"
          placeholder="Enter SAP ID or Name"
          maxlength="12">
        </b-form-input>
    </b-form-group>

  </b-form>

  <div v-show="createNotificationErrorMsg">
    Error creating notification: {{ createNotificationErrorMsg }}
  </div>

  <div class="create-button">
    <b-button v-show="!authenticating && !submitting && !doneSubmitting" :disabled="!enableCreate" class="create-notification" variant="primary" @click="onSubmit()">Create Notification</b-button>
  </div>

  <div v-show="submitting" class="submitting">
    Submitting ....
  </div>

  <div v-show="doneSubmitting" class="done-submitting">
    A new notification was successfully created with id: {{ newNotification.notificationId }}
  </div>
</div>
</template>

<script>
import axios from 'axios';
import notificationService from '../services/notificationService';
const _ = require('lodash');

export default {
  data() {
    return {
      locationEquipment: [],
      priorities: [],
      augInfo: {
        userEmail: null,
        jobId: null
      },
      locationFilter: null,
      newNotification: {
        FunctLoc: null,
        equipmentId: null,
        priority: null,
        shortDesc: null,
        longDesc: null,
        notificationId: null,
        SAPId: ""
      },
      pageHeading: 'Create Notification',
      submitting: false,
      authenticating: true,
      authenticationError: null,
      doneSubmitting: false,
      createNotificationErrorMsg: null
    };
  },
  computed: {
    SAPId: function() {
      return this.newNotification.SAPId || "SAP ID mapping missing";
    },
    locationOptions: function() {
      let options = [];

      if (this.locationEquipment) {
        let objs = _.map(this.locationEquipment, (loc) => {
          let obj = {
            text: loc.FunctLoc,
            value: loc.FunctLoc
          };
          if (!_.isNil(loc.FunctLocDesc)) {
            obj.text += ": " + loc.FunctLocDesc;
          }
          return obj;
        });
        options = _.uniqBy(objs, 'value');
      }

      return options;
    },
    equipmentOptions: function() {
      let options = [];

      if (this.newNotification.FunctLoc) {
        let filteredLocEquip = this.locationEquipment.filter(loc => loc.FunctLoc === this.newNotification.FunctLoc);
        options = filteredLocEquip.map(locEquip => { return { value: locEquip.EquipmentId, text: locEquip.EquipmentName } });
      }

      return options;
    },
    locationState: function() {
      return !!this.newNotification.FunctLoc;
    },
    equipmentState: function() {
      return !!this.newNotification.equipmentId;
    },
    shortDescriptionState: function() {
      return !!this.newNotification.shortDesc;
    },
    longDescriptionState: function() {
      return !!this.newNotification.longDesc;
    },
    priorityState: function() {
      return !!this.newNotification.priority;
    },
    sapIdState: function() {
      return !!this.newNotification.SAPId;
    },
    formEnabled: function() {
      return !this.authenticating && !this.submitting && !this.doneSubmitting
    },
    enableCreate: function() {
      return (this.locationState &&
        this.equipmentState &&
        this.priorityState &&
        this.shortDescriptionState &&
        this.longDescriptionState &&
        this.sapIdState
      );
    }
  },
  methods: {
    convertEmailToName: function(email) {
      let name = '';
      if (!email) {
        return name;
      }

      try {
        let userPart = _.split(email, '@', 2)[0].substring(0, 12);
        name = userPart.replace(/[^\w\s]|_/g, "").replace(/\s+/g, " ")
      } catch (e) {
        console.error('Error parsing name from email', e);
      }

      return name;
    },
    onSubmit: async function() {
      this.createNotificationErrorMsg = null;

      let pmWkctr;
      let equipment = this.locationEquipment.find(equipment => equipment.EquipmentId === this.newNotification.equipmentId);
      if (equipment && equipment.Wkctr) {
        pmWkctr = equipment.Wkctr;
      }

      let maintPlant = this.newNotification.FunctLoc.substring(0, this.newNotification.FunctLoc.indexOf('-'));

      this.submitting = true;
      try {
        let response = await notificationService.createNotification(this.newNotification, maintPlant, pmWkctr)
        this.submitting = false;

        if (response) {
          if (response.status === 200 && response.data.success) {
            this.pageHeading = 'Notification created';
            this.newNotification.notificationId = response.data.notificationId;
            this.doneSubmitting = true;
          } else {
            this.createNotificationErrorMsg = response.data.errorMsg;
          }
        } else {
          this.createNotificationErrorMsg = 'Error creating new notification';
        }
      } catch (e) {
        this.submitting = false;
        this.createNotificationErrorMsg = 'Error creating new notification. ';
        console.error('Exception creating notification: ', e);
      }
    }
  },
  mounted: async function() {
    let token = null;
    try {
      this.augInfo.jobId = this.$route.query._aug_jobId;
      this.augInfo.userEmail = this.$route.query._aug_userEmail;
      if (this.$route.query.filter) {
        this.locationFilter = this.$route.query.filter;
      }
      token = this.$route.query._aug_authToken;
    } catch (e) {
      console.error('Exception getting _aug_jobId, _aug_userEmail, _aug_authToken, check notification integration');
    }

    let env = {
      API_URL: 'http://localhost:7071/api/'
    }

    if (process.env.NODE_ENV !== 'development') {
      try {
        console.log('Fetching env settings');
        let response = await axios.get('/public/env.json', { headers: { 'cache-control': 'no-store,max-age=0' } });
        if (response && response.status === 200 && response.data) {
          _.merge(env, response.data);
        }
      } catch (e) {
        console.error(e);
      }
    }

    notificationService.init(env.API_URL, this.augInfo.userEmail, token);
    try {
      let authenticated = await notificationService.validateUserToken();
      if (authenticated) {
        this.authenticating = false;
      } else {
        this.authenticationError = 'Error authenticating.  Please contact your administrator';
        return;
      }
    } catch (e) {
      this.authenticationError = 'Error authenticating.  Please contact your administrator'
      console.error('Exception authenticating session', e);
      return;
    }

    this.locationEquipment = await notificationService.getLocationEquipment(this.locationFilter);
    this.priorities = await notificationService.getPriorities();
    let SAPId = await notificationService.getSAPId();
    if (SAPId) {
      this.newNotification.SAPId = SAPId;
    } else {
      this.newNotification.SAPId = this.convertEmailToName(this.augInfo.userEmail);
    }
  }
};
</script>

<style>
  .create-form {
    text-align: left;
    padding: 20px;
  }

  .create-button {
    padding-bottom: 20px;
  }

  .create-notification {
    margin: 20px;
    margin-bottom: 60px;
    background: blue;
    color: white;
    text-align: center;
  }

  .debug-info {
    opacity: 0.5;
  }
</style>



// WEBPACK FOOTER //
// src/components/CreateNotification.vue